import * as React from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { inviteSubcontractor } from "@/lib/api";

export function useInviteSubcontractorViewModel() {
  const queryClient = useQueryClient();
  const [inviteForm, setInviteForm] = React.useState({
    email: "",
    full_name: "",
    company_name: "",
    send_on: "",
  });
  const [inviteSuccess, setInviteSuccess] = React.useState("");
  const inviteSubcontractorMutation = useMutation({
    mutationFn: () => inviteSubcontractor(inviteForm),
    onSuccess: async (created) => {
      const sendOn = inviteForm.send_on;
      setInviteForm({ email: "", full_name: "", company_name: "", send_on: "" });
      if (sendOn && created.invite_sent_at == null) {
        setInviteSuccess(`Invitation scheduled for ${sendOn}.`);
      } else {
        setInviteSuccess("Invitation sent successfully.");
      }
      await queryClient.invalidateQueries({ queryKey: ["users"] });
      setTimeout(() => setInviteSuccess(""), 4000);
    },
    onError: (_err: unknown) => {
      setInviteSuccess("");
    },
  });
  return { inviteForm, setInviteForm, inviteSuccess, inviteSubcontractorMutation };
}
